<template>
    <div class="main-container-l">
        <div class="loading-container" v-if="loading">
            <!-- <img src="../../../../assets/img/loading.svg" /> -->
        </div>
        <lotto-games-menu v-if="!initialLoad && offerStore.lottoOfferInitialized"
            @selectlotto="selectLotto"
            @selectnumber="selectedNumber"
            @loaded="numbersLoaded"
            :isMobile.prop="isMobile"
            :offer.prop="offerInstance"
            :selectedLottoId.prop="selectedLottoId"
            :lottoMapping.prop="globals.props.lottoMapping"
            :selectNums.prop="selectNums"
            :betslip.prop="betslip"
            :clientStylingUrl.prop="styleUrl"
            :t.prop="$t"
            class="mr-1 lotto-main-menu-container desktop-web-cmp"
            :customCss.prop="customCss"
            >
            <div slot="current-balance" class="current-balance" v-if="showBalance && isMobile">
                <div class="balance">
                    <p>{{$t('CURRENTBALLANCE')}}:</p>
                    <span class="balance-value" ref_testcafe="virtual_terminal_balance">{{playerdata.money.balance | formatNum}}
                        <span class="light-text">{{ $getCurrencyAbbrv(playerdata.money.currency) }}</span>
                    </span>
                </div>
                <img src="../../../assets/img/icon-balance.svg" class="icon-balance">
            </div>
            <div slot="lotto-mobile" v-if="isMobile">
                <div v-if="selectedLottoNew != null" class="game-details matches-container prematch">
                    <div class="loto-game singleLotoGame"
                        :class="{'is-blocked': selectedLottoNew != null && selectedLottoNew.status === 'block'}">
                            <lotto-header  v-if="!loadingOffer && offerStore.lottoOfferInitialized"
                               :lottoMapping.prop="globals.props.lottoMapping"
                                :selectedLottoId.prop="selectedLottoNew.lottoId"
                                :isMobile.prop="isMobile"
                                :offer.prop="offerInstance"
                                :t.prop="$t"
                                :customCss.prop="customCss"
                                :clientStylingUrl.prop="styleUrl"
                                :showHelpGlobals.prop="globals.publicConfig.showHelp"
                                @togglehelppagestep="toggleHelpPageStep"
                                />
                            <lotto-favourites v-if="!loadingOffer && offerStore.lottoOfferInitialized"
                                @selectedfavorites="selectedFavorites"
                                :isMobile.prop="isMobile"
                                :selectedLottoId.prop="selectedLottoNew.lottoId"
                                :selectedNumbers.prop="selectNums"
                                :offer.prop="offerInstance"
                                :t.prop="$t"
                                :customCss.prop="customCss"
                                :clientStylingUrl.prop="styleUrl"
                                />
                            <offer-calendar v-if="calendarActive"
                                @selectdate="changeDate"
                                :timezone.prop="globals.publicConfig.localeSetup.timezone"
                                :isMobile.prop="isMobile"
                                :startDate.prop="startDateOffer"
                                :customCss.prop="customCss"
                                :clientStylingUrl.prop="styleUrl"
                                :t.prop="$t"
                                />
                            <lotto-draws-offer v-if="!initialLoad && offerStore.lottoOfferInitialized" v-show="!loadingOffer"
                                @selected="selectedOffer"
                                @changelimit="changeLimit"
                                @togglecalendar="toggleCalendar"
                                @defaultLimit="defaultLimit"
                                @togglehelppagestep="toggleHelpPageStep"
                                @reloadOffer="refetchOffer"
                                :isMobile.prop="isMobile"
                                :selectedLottoId.prop="selectedLottoNew.lottoId"
                                :selectedOffers.prop="betslipStore.betslipSelectedOffers"
                                :offer.prop="offerInstance"
                                :lottoDrawsPredefinedNumber.prop="globals.publicConfig.ssbt.lottoDrawsPredefinedNumber"
                                :lottoNextDrawCounterRange.prop="globals.publicConfig.ssbt.lottoNextDrawCounterRange"
                                :t.prop="$t"
                                :dateChanged.prop="dateChanged"
                                :customCss.prop="customCss"
                                :clientStylingUrl.prop="styleUrl"
                                :showHelpGlobals.prop="globals.publicConfig.showHelp"
                                />

                            <lotto-numbers v-if="!loadingOffer && offerStore.lottoOfferInitialized"
                                :offer.prop="offerInstance"
                                :isMobile.prop="isMobile"
                                :t.prop="$t"
                                :selectedLottoId.prop="selectedLottoNew.lottoId"
                                :selectedLottoOfferId.prop="currentSelectedOffers[0]"
                                :selectNums.prop="selectNums"
                                :betslip.prop="betslip"
                                :customCss.prop="customCss"
                                :clientStylingUrl.prop="styleUrl"
                                :showHelpGlobals.prop="globals.publicConfig.showHelp"
                                @selectnumber="selectedNumber"
                                @loaded="numbersLoaded"
                                @togglehelppagestep="toggleHelpPageStep"
                                />

                                <retail-lotto-animation v-if="globals.publicConfig.showLottoAnimation"
                                :lottoMapping.prop="globals.props.lottoMapping"
                                :offer.prop="offerInstance"
                                :selectedLottoId.prop="selectedLottoNew.lottoId"
                                :clientStylingUrl.prop="styleUrl"
                                :lottoNextDrawCounterRange.prop="globals.publicConfig.ssbt.lottoNextDrawCounterRange"
                                :t.prop="$t"
                                class="lotto-animation-container"
                                />
                    </div>
                </div>
            </div>
        </lotto-games-menu>

        <div class="game-details-container-l" style="width: 100%; overflow: hidden;" v-if="!isMobile">
            <div v-if="selectedLottoNew != null" class="game-details matches-container prematch">
                    <div class="loto-game singleLotoGame"
  :class="{'is-blocked': selectedLottoNew != null && selectedLottoNew.status === 'block'}">
                        <lotto-header  v-if="!loadingOffer && offerStore.lottoOfferInitialized"
                        :lottoMapping.prop="globals.props.lottoMapping"
                        :selectedLottoId.prop="selectedLottoNew.lottoId"
                        :isMobile.prop="isMobile"
                        :offer.prop="offerInstance"
                        :t.prop="$t"
                        :customCss.prop="customCss"
                        :clientStylingUrl.prop="styleUrl"
                        :showHelpGlobals.prop="globals.publicConfig.showHelp"
                        @togglehelppagestep="toggleHelpPageStep"
                        />
                        <div class="single-lotto-column">
                            <div class="single-lotto-offer">
                                <lotto-favourites v-if="!loadingOffer && offerStore.lottoOfferInitialized"
                                @selectedfavorites="selectedFavorites"
                                :isMobile.prop="isMobile"
                                :selectedLottoId.prop="selectedLottoNew.lottoId"
                                :selectedNumbers.prop="selectNums"
                                :offer.prop="offerInstance"
                                :t.prop="$t"
                                :customCss.prop="customCss"
                                :clientStylingUrl.prop="styleUrl"
                                />
                                <offer-calendar v-if="calendarActive"
                                @selectdate="changeDate"
                                :timezone.prop="globals.publicConfig.localeSetup.timezone"
                                :isMobile.prop="isMobile"
                                :startDate.prop="startDateOffer"
                                :customCss.prop="customCss"
                                :clientStylingUrl.prop="styleUrl"
                                :t.prop="$t"
                                />
                                <lotto-draws-offer v-if="!initialLoad && offerStore.lottoOfferInitialized" v-show="!loadingOffer"
                                @selected="selectedOffer"
                                @changelimit="changeLimit"
                                @togglecalendar="toggleCalendar"
                                @defaultLimit="defaultLimit"
                                @togglehelppagestep="toggleHelpPageStep"
                                @reloadOffer="refetchOffer"
                                :isMobile.prop="isMobile"
                                :selectedLottoId.prop="selectedLottoNew.lottoId"
                                :selectedOffers.prop="betslipStore.betslipSelectedOffers"
                                :offer.prop="offerInstance"
                                :lottoDrawsPredefinedNumber.prop="globals.publicConfig.ssbt.lottoDrawsPredefinedNumber"
                                :lottoNextDrawCounterRange.prop="globals.publicConfig.ssbt.lottoNextDrawCounterRange"
                                :t.prop="$t"
                                :dateChanged.prop="dateChanged"
                                :customCss.prop="customCss"
                                :clientStylingUrl.prop="styleUrl"
                                :showHelpGlobals.prop="globals.publicConfig.showHelp"
                                />

                                <lotto-numbers v-if="!loadingOffer && offerStore.lottoOfferInitialized"
                                :offer.prop="offerInstance"
                                :isMobile.prop="isMobile"
                                :t.prop="$t"
                                :selectedLottoId.prop="selectedLottoNew.lottoId"
                                :selectedLottoOfferId.prop="currentSelectedOffers[0]"
                                :selectNums.prop="selectNums"
                                @selectnumber="selectedNumber"
                                @loaded="numbersLoaded"
                                :betslip.prop="betslip"
                                :customCss.prop="customCss"
                                :clientStylingUrl.prop="styleUrl"
                                />
                                <div class="loto-legend">
                                    <div class="loto-number-box">
                                        <div class="loto-top-num">7</div>
                                        <div class="loto-big-num is-desktop">
                                            <div class="loto-ball-shadow"></div>
                                            <div class="loto-big-num-inner">82</div>
                                        </div>
                                        <div class="loto-bottom-num">2</div>
                                    </div>
                                    <div class="legend-description">
                                        <div class="top-number"><span>7</span>{{$t('TIMESLOTTONUMWASDRAWN')}}</div>
                                        <div class="bottom-number"><span>2</span>{{$t('TIMESLOTTONUMWASNOTDRAWN')}}</div>
                                    </div>
                                </div>
                            </div>
                            <retail-lotto-animation v-if="globals.publicConfig.showLottoAnimation"
                            :lottoMapping.prop="globals.props.lottoMapping"
                            :offer.prop="offerInstance"
                            :selectedLottoId.prop="selectedLottoNew.lottoId"
                            :lottoNextDrawCounterRange.prop="globals.publicConfig.ssbt.lottoNextDrawCounterRange"
                            :t.prop="$t"
                            class="lotto-animation-container"
                            />
                        </div>
                    </div>
            </div>
        </div>
        <new-betslip v-if="betslipStore && betslip"
        />

        <lotto-tutorial
            :t.prop="$t"
            :show.prop="showHelp"
            :pageNumber.prop="pageNumber"
            :customCss.prop="customCss"
            :clientStylingUrl.prop="styleUrl"
            @closehelppage="closeHelp"
            @resetpage="resetPage"
        />

    </div>
</template>

<script>
import { mapState as piniaState } from 'pinia';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment-timezone';
import { useBetslipStore } from '../../store/piniaStore/betslip';
import { useOfferStore } from '../../store/piniaStore/offer';
import { useCustomizationStore } from '../../store/piniaStore/customization';
import NewBetslip from '../../components/betslip/NewBetslip.vue';
import '@om-retail/retail-lotto-animation/es2015/retail-lotto-animation';

export default {
    name: 'Loto',
    components:
    {
        NewBetslip,
    },

    data()
    {
        return {
            betslip: null,
            dateChanged: true,
            startDateOffer: null,
            endDateOffer: null,
            offerStore: null,
            selectedLottoId: null,
            selectedLottoNew: null,
            loadingOffer: true,
            styleUrl: '/web/css/fe-style.css,/web/css/assets.css',
            betslipStore: null,
            lottoId: null,
            initialLoad: true,
            refreshCalendar: false,
            currentSelectedOffers: [],
            calendarActive: false,
            offerInstance: null,
            selectNums: null,
            load: false,
            lottoChange: false,
            pageNumber: 1,
        };
    },
    async created()
    {
        const me = this;

        if (this.checkMaintenance())
        {
            return;
        }

        this.betslipStore = useBetslipStore();
        this.betslip = this.betslipStore.getBetslip();
        this.offerStore = useOfferStore();
        this.offerInstance = this.offerStore.getOfferInstance();
        await me.betslip.wipeBetslipData();
        await me.betslipStore.clearItems(['lotto', 'lotto_extended'], true);
        me.betslip.changeBetslipDefinition('combination');
        await this.initialComponentSetup();
    },
    async beforeDestroy()
    {
        const me = this;
        me.betslip.wipeBetslipData();
        await me.offerStore.destroyLottoOffer({
            ignore: ['sport', 'vhorse'],
        });
    },
    methods: {
        ...mapActions([
            'setPageHelpDisplayed',
        ]),
        // Select lotto on games menu component
        async selectLotto(emitData)
        {
            const me = this;
            const data = emitData.detail[0];

            me.selectedLottoId = data.lottoId;
            me.lottoToRoute(me.selectedLottoId);
            me.setLastSelectedLottery(me.selectedLottoId);

            me.selectedLottoNew = null;
            this.betslipStore.betslipSelectedOffers = [];

            // Fetch offer for new lotto
            await me.fetchOffer({
                lottoId: me.selectedLottoId,
                limit: 20,
                startDate: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
                endDate: moment().utc().add(8760, 'd').format('YYYY-MM-DD HH:mm:ss'),
            });

            let tempNums = [];
            if (localStorage.getItem('lottoNumbers'))
            {
                tempNums = JSON.parse(String(localStorage.getItem('lottoNumbers')));
            }

            for (const num of tempNums)
            {
                if (Number(num) > Number(this.selectedLottoNew.numbersOff))
                {
                    me.lottoChange = true;
                    break;
                }
            }
            me.selectNums = [...tempNums];
        },
        // Fetch offer function
        async fetchOffer(lottoData)
        {
            const me = this;
            this.load = true;
            me.loadingOffer = lottoData.rerender != null ? lottoData.rerender : true;
            await me.offerStore.fetchLottoOffer(
                {
                    lottoId: String(lottoData.lottoId),
                    lottoData: lottoData.limit,
                    startDate: lottoData.startDate,
                    endDate: lottoData.endDate,
                },
            );
            this.load = false;
            me.loadingOffer = false;
            me.selectedLottoNew = me.offerInstance.lotto.lottos[String(lottoData.lottoId)];
        },
        // Set last selected lottery in local storage
        setLastSelectedLottery(lottoId = null)
        {
            try
            {
                localStorage.setItem(
                    'lastSelectedLottery',
                    lottoId,
                );
            }
            catch (e)
            {
                console.log(e);
            }
        },
        // Push lotto id to route
        lottoToRoute(lottoId)
        {
            const me = this;
            if (me.betslip.betslipLoading)
            {
                return;
            }

            me.$router.push({
                params:
                {
                    lottoId,
                },
            }).catch((e) => e);
        },
        // Fetch offers for selected date
        async changeDate(val)
        {
            this.startDateOffer = val.detail[0].startDate;
            this.endDateOffer = val.detail[0].endDate;
            this.betslipStore.betslipSelectedOffers = [];
            await this.fetchOffer({
                lottoId: this.selectedLottoNew.lottoId,
                limit: 20,
                startDate: val.detail[0].startDate,
                endDate: val.detail[0].endDate,
            });

            if (window.localStorage.getItem('lottoNumbers'))
            {
                this.selectNums = JSON.parse(window.localStorage.getItem('lottoNumbers'));
            }

            this.dateChanged = !this.dateChanged;
            this.calendarActive = true;
        },
        // Select new betslip based on first offer
        async selectedOffer(val)
        {
            const me = this;
            this.betslipStore.betslipList = [...val.detail[0]];
            this.currentSelectedOffers = this.betslipStore.betslipList.map((item) => item.drawId);

            // Swap lottery when draws change
            const firstOffer = me.selectedLottoNew.offers.get(this.betslipStore.betslipList[0].drawId);

            await me.betslip.swapLottery(
                {
                    eventId: String(firstOffer.lottoOfferId),
                    code: firstOffer.code,
                    eventDate: firstOffer.dateTime,
                    eventName: firstOffer.name,
                    type: 'lotto',
                    status: firstOffer.status,
                    restrictions: (firstOffer.restrictions) ? firstOffer.restrictions : firstOffer.rules,
                    meta:
                    {
                        lottoType: 'drawn',
                        outcomes: firstOffer.odds,
                        numbersToGuess: firstOffer.numbersToGuess,
                        numbersOff: firstOffer.numbersOff,
                        lottoId: firstOffer.lottoId,
                    },
                },
                {
                    overrideLoading: true,
                    numbers: me.selectNums,
                },
            );
        },
        // Increase limit of offers
        async changeLimit(val)
        {
            await this.fetchOffer({
                lottoId: this.selectedLottoNew.lottoId,
                limit: val.detail[0],
                startDate: this.startDateOffer ? this.startDateOffer : moment().utc().format('YYYY-MM-DD HH:mm:ss'),
                endDate: this.endDateOffer
                    ? this.endDateOffer : moment().utc().add(8760, 'd').format('YYYY-MM-DD HH:mm:ss'),
                rerender: false,
            });
        },
        defaultLimit(val)
        {
            [this.betslipStore.defaultLimit] = val.detail;
        },
        // Activate calendar
        toggleCalendar()
        {
            this.calendarActive = !this.calendarActive;
        },
        resetPage()
        {
            this.pageNumber = null;
        },
        async refetchOffer()
        {
            await this.fetchOffer({
                lottoId: this.selectedLottoNew.lottoId,
                limit: 20,
                startDate: this.startDateOffer ? this.startDateOffer : moment().utc().format('YYYY-MM-DD HH:mm:ss'),
                endDate: this.endDateOffer
                    ? this.endDateOffer : moment().utc().add(8760, 'd').format('YYYY-MM-DD HH:mm:ss'),
            });
        },
        closeHelp()
        {
            this.setPageHelpDisplayed('lotto');
        },
        // Add new number to local storage and send them to favourites web components
        async selectedNumber(val)
        {
            const me = this;
            const data = val.detail[0];
            const selectedOdds = [];

            for (const odd of data)
            {
                selectedOdds.push(odd);
            }

            me.selectNums = [...selectedOdds];
            if (!me.lottoChange)
            {
                window.localStorage.setItem(
                    'lottoNumbers',
                    JSON.stringify(me.selectNums),
                );
            }

            me.lottoChange = false;
        },
        // Select favourites numbers
        selectedFavorites(val)
        {
            const me = this;
            const numbers = val.detail[0];
            me.selectNums = numbers;
        },
        numbersLoaded(data)
        {
            this.load = !data.detail[0];
        },

        async initialComponentSetup()
        {
            const me = this;

            me.initialLoad = true;
            await this.offerStore.initLottoOffer();
            me.initialLoad = false;

            // Check local storage for last lottery
            if (window.localStorage.getItem('lastSelectedLottery'))
            {
                me.selectedLottoId = window.localStorage.getItem('lastSelectedLottery');
                me.lottoToRoute(me.selectedLottoId);
            }

            // Check route id for lotto and fetch offer for that lotto initialy
            if (me.$route.params.lottoId)
            {
                me.selectedLottoId = me.$route.params.lottoId;
                // Set last selected lottery in store
                me.setLastSelectedLottery(me.$route.params.lottoId);
                me.selectNums = window.localStorage.getItem('lottoNumbers')
                    ? JSON.parse(window.localStorage.getItem('lottoNumbers')) : [];

                me.fetchOffer({
                    lottoId: me.selectedLottoId,
                    limit: 20,
                    startDate: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
                    endDate: moment().utc().add(8760, 'd').format('YYYY-MM-DD HH:mm:ss'),
                });
            }
            else if (Object.values(this.offerInstance.lotto.lottos)[0].lottoId)
            {
                const firstLotto = Object.values(this.offerInstance.lotto.lottos)[0].lottoId;
                me.lottoToRoute(firstLotto);
                me.selectedLottoId = firstLotto;
                // Set last selected lottery in store
                me.setLastSelectedLottery(firstLotto);
                me.selectNums = window.localStorage.getItem('lottoNumbers')
                    ? JSON.parse(window.localStorage.getItem('lottoNumbers')) : [];

                me.fetchOffer({
                    lottoId: me.selectedLottoId,
                    limit: 20,
                    startDate: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
                    endDate: moment().utc().add(8760, 'd').format('YYYY-MM-DD HH:mm:ss'),
                });
            }
        },
        toggleHelpPageStep(data)
        {
            [this.pageNumber] = data.detail;
        },
        checkMaintenance()
        {
            if (this.maintenance && this.maintenance.lotto)
            {
                this.$router.push({ name: 'maintenance' });
            }
        },
    },
    computed: {
        ...mapGetters([
            'isMobile',
            'globals',
            'showHelpOnPages',
            'playerdata',
            'maintenance',
        ]),
        ...piniaState(useCustomizationStore, ['customCss']),
        lottoMapping()
        {
            const me = this;

            if (me.globals
            && me.globals.props
            && me.globals.props.lottoMapping)
            {
                return me.globals.props.lottoMapping;
            }
            return {};
        },
        loading()
        {
            if (this.loadingOffer || this.initialLoad || this.selectedLottoNew == null || this.load)
            {
                return true;
            }

            return false;
        },
        showHelp()
        {
            return this.globals
            && this.globals.publicConfig
            && this.globals.publicConfig.showHelp
            && this.showHelpOnPages.lotto;
        },
        showBalance()
        {
            const me = this;

            if (me.globals.publicConfig.asCasinoGame && me.playerdata.money)
            {
                return true;
            }

            return false;
        },
    },
    watch:
    {
        'betslip.betslipDef':
        {
            handler()
            {
                this.betslip.changeBetslipDefinition('combination');
            },
        },
        selectedLottoId:
        {
            handler()
            {
                const me = this;
                me.calendarActive = false;
                me.startDateOffer = null;
            },
        },
        'betslipStore.betslipSelectedNumbers':
        {
            async handler(value)
            {
                this.selectNums = value;
            },
            deep: true,
        },
        async 'globals.langCode'()
        {
            await this.offerStore.destroyLottoOffer();
            await this.offerStore.destroyOffer();
            await this.offerStore.initOffer();
            await this.initialComponentSetup();
        },
        maintenance()
        {
            this.checkMaintenance();
        },
    },
};
</script>
